<template>
  <div ref="infiniteScrollSentinel" />
</template>

<script>
export default {
  name: "InfiniteScrollObserver",
  components: {},
  props: {
    horizontalScrollable: {
      type: Boolean,
      default: false
    },
    customRootMargin: {
      type: String,
      default: ""
    }
  },
  data: function() {
    return {
      infiniteScrollSentinel: null,
      infiniteScrollObserver: null
    };
  },
  computed: {},
  mounted() {
    this.infiniteScrollSentinel = this.$refs.infiniteScrollSentinel;
    this.infiniteScrollObserver = new IntersectionObserver(this.handleIntersection, {
      root: null,
      rootMargin: this.customRootMargin ? this.customRootMargin : (this.horizontalScrollable ? "0px 20% 0px -20%" : "0px"),
      threshold: this.horizontalScrollable ? 0.0 : 1.0
    });
    this.infiniteScrollObserver.observe(this.infiniteScrollSentinel);
  },
  beforeDestroy() {
    if (this.infiniteScrollObserver) {
      this.infiniteScrollObserver.disconnect();
    }
  },
  methods: {
    handleIntersection(entries) {
      if (entries[0].isIntersecting) {
        this.$emit("intersect");
      }
    }
  }
}
</script>